export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtEMAILText';
export const NAME = 'EmailText';
